module.exports = __webpack_public_path__ + "img/icon-vot-payoutsetting.092b84d5.png";